import axios from 'axios'

//const url = 'linkdrive/plataforma/acesso-publico/anuncio'
const urlP = 'linkdrive/plataforma/acesso-privado'

const state = {
  meusAnuncios: [],
  segmentos: [],
  validadeAnuncio: 0,
}

const getters = {
  meusAnuncios: state => state.meusAnuncios,
  segmentos: state => state.segmentos,
  validadeAnuncio: state => state.validadeAnuncio,
}

const mutations = {
  setMeusAnuncios: (state, payload) => state.meusAnuncios = payload,
  setSegmentos: (state, payload) => state.segmentos = payload,
  setValidadeAnuncio: (state, payload) => state.validadeAnuncio = payload,
}

const actions = {
  async getMeusAnuncios({ commit }, status) {
    const { data: anuncios } = await axios(`${urlP}/anuncio/meus-anuncios/status/${status}/lista/100/pagina/1`)
    commit('setMeusAnuncios', anuncios)
  },
  async getSegmentos({ commit }) {
    const { data: segmentos } = await axios(`${urlP}/anuncio/segmentos`)
    commit('setSegmentos', segmentos)
  },
  async cadastrarAnuncio(_, params) {
    const { data: resp } = await axios.post(`${urlP}/anuncio`, params)
    return resp
  },
  async cadastrarImagemAnuncio(_, params) {
    const id = params.get('id')
    params.delete('id')
    await axios.post(`${urlP}/anuncio/${id}/imagem`, params)
  },
  async validadeAnuncio({ commit }) { 
    const { data: validade } = await axios.get(`${urlP}/parametros-gerais`)
    commit('setValidadeAnuncio', validade['dias-cadastro-anuncio'])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}